module.exports = __webpack_public_path__ + "static/moradin-symbol-DND3_FnP-e398eb4288e963ec16808fddb97c3e4e.webp";